module.exports = __webpack_public_path__ + "static/media/valmetlogo.5a937205.svg";